import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './providers/ThemeProvider';
import VideoProvider from './providers/VideoContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <VideoProvider>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </VideoProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();

// Service worker : coquille en cache, démarrage instantané, application
// installable sur mobile. Uniquement en production — en développement il
// masquerait les rechargements à chaud.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL}/sw.js`)
            .catch((error) => console.error('Service worker non enregistré :', error));
    });
}
